<script setup>
/* Store */
import { useFlashMessagesStore } from '../store/flashMessages.js';

/* Init store */
const flashMessagesStore = useFlashMessagesStore();

/* Handle close btn */
const onClose = (msg, index) => {
  if (msg.onClose) msg.onClose();

  flashMessagesStore.removeFlashMessage(index);
};
</script>

<template>
  <div class="flash-messages">
    <g-alert
      v-for="(msg, index) in flashMessagesStore.getFlashMessages"
      :key="index"
      show
      :slot-align="msg.align"
      :type="msg.type"
      :closeable="msg.closeable"
      :left-icon="msg.leftIcon"
      :dataTestId="{
        host: `flash-message-${msg.testId}`,
        alert: `flash-message-${msg.testId}-alert`,
        icon: `flash-message-${msg.testId}-icon`,
        closeButton: `flash-message-${msg.testId}-close`,
      }"
      @g-close="() => onClose(msg, index)"
    >
      {{ msg.text }}
    </g-alert>
  </div>
</template>
